import { httpService } from './http.service.js'

// Caching למניעת קריאות חוזרות
const cache = {}

export const watchlistAxios = {
  searchAnime,
}

async function searchAnime(query, page = 1) {
  if (!query.trim()) return []

  const cacheKey = `${query}_${page}`
  if (cache[cacheKey]) {
    return cache[cacheKey]
  }

  try {
    const params = new URLSearchParams({
      title: query, // שולח ל-Backend לפי `title`
      page,
      limit: 30, // שולח בקשות ל-30 תוצאות בכל עמוד
    }).toString()

    const results = await httpService.get(`anime?${params}`) || []

    // שמירת התוצאות ב־Cache
    cache[cacheKey] = results
    return results
  } catch (error) {
    console.error('❌ שגיאה בחיפוש האנימה:', error)
    throw error
  }
}
